import colors from '@/utils/colors';

export default {
  data() {
    return {
      pendingColor: colors.statusColor.pending,
      openedColor: colors.statusColor.opened,
      holdingColor: colors.statusColor.holding,
      repliedColor: colors.statusColor.replied,
      closedColor: colors.statusColor.closed,
      ignoredColor: colors.statusColor.ignored,

      values: [
        'opened',
        'pending',
        'holding',
        'replied',
        'closed',
        'ignored',
      ],
    };
  },
  computed: {
    pendingLabel() {
      return this.$t('mixins.statusModel.pendingLabel');
    },
    openedLabel() {
      return this.$t('mixins.statusModel.openedLabel');
    },
    holdingLabel() {
      return this.$t('mixins.statusModel.holdingLabel');
    },
    repliedLabel() {
      return this.$t('mixins.statusModel.repliedLabel');
    },
    closedLabel() {
      return this.$t('mixins.statusModel.closedLabel');
    },
    ignoredLabel() {
      return this.$t('mixins.statusModel.ignoredLabel');
    },
  },
  methods: {
    getAll() {
      return this.values.map(value => {
        const obj = this.getStatusObj(value);
        return {
          ...obj,
          value,
        };
      });
    },
    getStatusObj(title) {
      return {
        color: this[`${title}Color`],
        name: this[`${title}Label`],
      };
    },
    // eslint-disable-next-line complexity
    getStatusColorAndName(title) {
      switch (title.toLowerCase()) {
      case 'pending':
      case 'pendente':
        return this.getStatusObj('pending');
      case 'open':
      case 'opened':
      case 'aberto':
        return this.getStatusObj('opened');
      case 'waiting':
      case 'holding':
      case 'em espera':
        return this.getStatusObj('holding');
      case 'replied':
      case 'respondido':
        return this.getStatusObj('replied');
      case 'finished':
      case 'closed':
      case 'fechado':
        return this.getStatusObj('closed');
      case 'ignored':
      case 'ignorado':
      default:
        return this.getStatusObj('ignored');
      }
    },
  },
};
